import React from "react";
import { useTranslation } from "react-i18next";
import "./mfa-setup-alert.scss";

interface MfaSetupAlertProps {
  message?: string;
}

const MfaSetupAlert: React.FC<MfaSetupAlertProps> = ({ message }) => {
  const { t } = useTranslation();
  const displayMessage = message || t("MFA.SETUP_MFA_TO_PROCEED_WITH_WITHDRAWALS");
  
  return (
    <section className="mfa-setup-alert">
      <div className="mfa-setup-alert-content">
        <span className="mfa-setup-alert-icon">🔒</span>
        <p className="mfa-setup-alert-message">{displayMessage}</p>
      </div>
    </section>
  );
};

export default MfaSetupAlert;
